<section class="services section" id="services">
  <div class="shell-container">
    <div class="services__header reveal" appRevealOnScroll="80ms">
      <div>
        <div class="badge">{{ content.badge }}</div>
        <h2>{{ content.heading }}</h2>
        <p class="services__lede">{{ content.lede }}</p>
      </div>
    </div>

    <div class="services__grid">
      <a
        *ngFor="let service of content.cards"
        [attr.id]="service.id"
        [ngClass]="['service-card', service.accent, 'reveal']"
        [appRevealOnScroll]="'120ms'"
        [href]="service.url"
      >
        <div class="service-card__icon"></div>
        <div>
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </div>
        <span class="service-card__action">Explore Service</span>
      </a>
    </div>
  </div>
</section>
